import DoctorClinicNameRender from '@medical/components/DoctorClinicNameRender'
import StatusRender from '@medical/components/StatusRender'
import numeralCurrency from '@medical/libs/numeralCurrency'
import moment from 'moment'
import { formatExtendedTime } from '@medical/libs/extendedTimeUtils'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ActionItem } from './ActionItem'

export const WorkScheduleItem = ({ workSchedule, departmentNames }) => {
  const { i18n } = useTranslation()

  return (
    <div className='mobile-work-schedule-item'>
      <div style={{ marginBottom: '10px' }}>
        {i18n.t('main.clinicName')} :
        <span className='clinic-name'>
          {DoctorClinicNameRender({
            clinicalDepartment: workSchedule.clinicalDepartment,
          })}
        </span>
      </div>
      <div>
        <div>
          {i18n.t('main.departmentName')} :{' '}
          {departmentNames[workSchedule.clinicalDepartment.name]}
        </div>
        <div>
          {i18n.t('main.startTime')} :{' '}
          {formatExtendedTime(workSchedule.startTime, workSchedule.startTime)}
        </div>
        <div>
          {i18n.t('main.endTime')} :{' '}
          {formatExtendedTime(workSchedule.startTime, workSchedule.endTime)}
        </div>
        <div>
          {i18n.t('main.dailySalary')} :{' '}
          {numeralCurrency(workSchedule.acceptedShift.dailySalary)}
        </div>
        <div>
          {i18n.t('main.status')} : <StatusRender val={workSchedule.accepted} />
        </div>
      </div>
      <span className='action'>
        <ActionItem item={workSchedule} />
      </span>
    </div>
  )
}
